<template>
    <div style="text-align: center">
      <h1 style="text-align: left;padding:50px 120px">{{name}}:</h1>
      <div style="width: 85%;margin: auto">
        <img v-for="(i,index) in imagesData" v-lazy="i.url" :key="i.id" width="300px" style="margin: 10px" @click="clickImage(i.id)">
      </div>
      <Page ref="pages" :total=total :page-size="30" @on-change="pageClick"/>
    </div>
</template>

<script>
  import {ajaxFetch} from '../utils'
  export default {
    name: 'AlbumPage',
    data () {
      return {
        name: '',
        typeId: 0,
        total: 0,
        imagesData:[],
      }
    },
    mounted: function () {
      this.name = this.$route.query.name
      this.typeId = this.$route.query.id
      this.listByCategory(this.typeId,0)
    },
    methods: {
      listByCategory: function (id, current) {
        ajaxFetch('post','/client/productTable/listByCategory',{categoryId:id,current:current,size:30},(response) => {
          if (response.code === 200) {
            this.imagesData = response.data.data
            this.total = parseInt(response.data.total)
          } else {

          }
        }, (err) => {
          console.log(err)
        } )
      },
      pageClick: function(page) {
        this.listByCategory(this.typeId,page)
      },
      clickImage: function (id) {
        this.$router.push({name: 'detailImgPage', query: {id: id}})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AlbumPageDetail.vue